module.exports = __webpack_public_path__ + "img/03.da7215b4.png";